(() => {
  const text = window.bisNotifyText;
  const animation = window.bisButtonAnimation;
  const FALLBACK_TIMEOUT_MS = 6e3;
  const pendingClicks = new WeakSet();
  const fallbackTimers = new WeakMap();

  function placeholderFor(bisWrapper) {
    const placeholder = bisWrapper.previousElementSibling;
    return placeholder?.hasAttribute('data-bis-placeholder') ? placeholder : null;
  }

  function controlFor(placeholder) {
    return placeholder?.querySelector('button, a') || null;
  }

  function clearFallbackTimer(bisWrapper) {
    const timer = fallbackTimers.get(bisWrapper);
    if (timer) {
      clearTimeout(timer);
      fallbackTimers.delete(bisWrapper);
    }
  }

  // If the BIS widget never shows up (blocked, disabled, ineligible...), give up waiting
  // and fall back to a plain, disabled "sold out" button instead of spinning forever.
  function revertToFallback(bisWrapper) {
    pendingClicks.delete(bisWrapper);
    const placeholder = placeholderFor(bisWrapper);
    const control = controlFor(placeholder);
    if (!control) return;

    control.removeAttribute('aria-busy');
    if (placeholder.dataset.bisFallbackText) {
      (control.querySelector('button-content') || control).textContent = placeholder.dataset.bisFallbackText;
    }
    if ('disabled' in control) control.disabled = true;
  }

  // Clicking the placeholder before the real widget is ready: show a loading state and
  // remember to forward the click once the widget swaps in.
  function onPlaceholderClick(event) {
    const placeholder = event.target.closest('[data-bis-placeholder]');
    if (!placeholder) return;
    const bisWrapper = placeholder.nextElementSibling;
    if (!bisWrapper?.classList.contains('wc_wl_bis_btn') || !bisWrapper.hasAttribute('hidden')) return;

    event.preventDefault();
    const control = controlFor(placeholder);
    if (!control || control.getAttribute('aria-busy') === 'true') return;

    control.setAttribute('aria-busy', 'true');
    pendingClicks.add(bisWrapper);

    if (!fallbackTimers.has(bisWrapper)) {
      fallbackTimers.set(bisWrapper, setTimeout(() => {
        fallbackTimers.delete(bisWrapper);
        revertToFallback(bisWrapper);
      }, FALLBACK_TIMEOUT_MS));
    }
  }
  document.addEventListener('click', onPlaceholderClick, true);

  function wrapWithButtonContent(span) {
    if (span.closest("button-content")) return;

    const wrapper = document.createElement("button-content");
    wrapper.className = "button__content";

    if (animation === "rotation")
      wrapper.setAttribute("rotated-text", span.textContent.trim());
    else if (animation === "up")
      wrapper.setAttribute("up-text", span.textContent.trim());
    else if (animation === "glowing") wrapper.setAttribute("glowing", "");

    if (window.bisNotifyIcon) wrapper.insertAdjacentHTML("beforeend", window.bisNotifyIcon);

    span.replaceWith(wrapper);
    wrapper.appendChild(span);
  }

  function processEl(el) {
    if (text && el.textContent.trim() !== text) {
      el.textContent = text;
      const existing = el.closest("button-content");
      if (existing) {
        if (animation === "rotation")
          existing.setAttribute("rotated-text", text);
        else if (animation === "up") existing.setAttribute("up-text", text);
      }
    }

    wrapWithButtonContent(el);

    const btn = el.closest('button, a');
    if (btn && !btn.classList.contains('button')) btn.classList.add('button');

    const bisWrapper = el.closest('.wc_wl_bis_btn');
    if (bisWrapper?.hasAttribute('hidden')) {
      clearFallbackTimer(bisWrapper);
      bisWrapper.removeAttribute('hidden');

      const placeholder = placeholderFor(bisWrapper);
      if (placeholder) placeholder.style.display = 'none';

      if (pendingClicks.has(bisWrapper)) {
        pendingClicks.delete(bisWrapper);
        btn?.click();
      }
    }
  }

  function processAll(root = document) {
    for (const el of root.querySelectorAll(".wcBsiNotifyText")) processEl(el);
  }

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (node.matches?.(".wcBsiNotifyText")) processEl(node);
        else if (node.querySelector?.(".wcBsiNotifyText")) processAll(node);
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });

  processAll();
})();
